module.exports = __webpack_public_path__ + "static/media/4j8gDXusidn0CYgCvICo.e10e49aa.bin";